<template>
  <div class="ph-16">
    <div class="flex justify-between">
      <BlTextAv data-testid="multi-select-label" variation="body-16" weight="bold">{{ label }}</BlTextAv>
      <BlTextAv v-if="hasMore" data-testid="multi-select-more-cta" variation="caption-12">
        <BlLinkAv data-test-id="multi-select-more-link" @click="openSheet">Lihat Semua</BlLinkAv>
      </BlTextAv>
    </div>
    <div class="pt-16">
      <div v-for="item in options" :key="`selection-${label}-${item.value}`" class="inline-block p-4">
        <BlSelectionBlockMv
          data-testid="multi-select-selection-box"
          :is-active="isItemSelected(item.value)"
          :text="item.name"
          high-contrast
          @click="selectItem(item.value)"
        />
      </div>
    </div>
    <BlSheetMv
      v-if="hasMore"
      data-testid="multi-select-more-sheet"
      style="margin: 0 auto"
      class="max-w-[480px]"
      :active.sync="showMore"
      :title="label"
    >
      <div slot="content">
        <div class="relative">
          <div class="sticky z-40 bg-white top-0">
            <BlNavBarSearchMv :placeholder="`Cari ${label}`" @input="handleSearch" />
          </div>
          <div class="ph-16" style="overflow-y: scroll; height: 60vh">
            <div v-for="item in searchOptions" :key="`check-${label}-${item.value}`" class="block p-4">
              <BlCheckboxAv
                v-model="selectedSearchItems"
                data-testid="multi-select-check-box"
                :native-value="item.value"
                class="u-width-1 pv-4"
              >
                {{ item.name }}
              </BlCheckboxAv>
            </div>
          </div>
          <div id="prakerja-multi-select-footer-wrapper" slot="footer" :class="footerClasses">
            <BlButtonAv id="multi-select-submit-button" type="button" variation="primary" fullwidth @click="onSubmit">Terapkan</BlButtonAv>
          </div>
        </div>
      </div>
    </BlSheetMv>
  </div>
</template>

<script>
import {sortBy, uniqBy} from 'lodash';
import {BlButtonAv, BlSelectionBlockMv, BlTextAv, BlLinkAv, BlCheckboxAv, BlNavBarSearchMv} from '@bukalapak/bazaar-mweb-latest';
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';

const MAX_OPTIONS = 6;

export default {
  name: 'PrakerjaCoursesFilterMultiSelect',
  components: {
    BlButtonAv,
    BlSelectionBlockMv,
    BlTextAv,
    BlLinkAv,
    BlSheetMv,
    BlCheckboxAv,
    BlNavBarSearchMv,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    hasMore: {
      type: Boolean,
      default: false,
    },
    moreDataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showMore: false,
      keywords: '',
      showButton: false,
      options: [],
      searchOptions: [],
      selectedSearchItems: [],
    };
  },
  computed: {
    footerClasses() {
      let baseClass = 'p-16 border-t border-[#F1F2F5]';

      return this.showButton ? 'sticky bottom-0 bg-white ' + baseClass : `${baseClass} hidden`;
    },
    selectedItems: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('change', value);
      },
    },
  },
  watch: {
    selectedSearchItems() {
      this.showButton = true;
    },
    data(value) {
      this.options = value;
    },
    moreDataList(value) {
      this.searchOptions = value;
    },
  },
  mounted() {
    this.options = this.data;
    this.searchOptions = this.moreDataList;
  },
  methods: {
    isItemSelected(value) {
      return this.selectedItems.includes(value);
    },
    handleSearch(value) {
      this.searchOptions = this.moreDataList.filter((data) => data.name.toLowerCase().includes(value.toLowerCase()));
    },
    selectItem(value) {
      let index = this.selectedItems.indexOf(value);

      if (index < 0) {
        this.selectedItems.push(value);
      } else {
        this.selectedItems.splice(index, 1);
      }
    },
    openSheet() {
      this.selectedSearchItems = this.selectedItems;

      this.searchOptions = sortBy(this.moreDataList, (option) => (this.selectedItems.includes(option.value) ? 0 : 1));
      this.showMore = true;
    },
    onSubmit() {
      let newOptions = this.moreDataList.filter((data) => this.selectedSearchItems.includes(data.value));

      if (newOptions.length < MAX_OPTIONS) {
        newOptions = uniqBy([...newOptions, ...this.data], 'value');
        newOptions = newOptions.slice(0, MAX_OPTIONS);
      }

      this.options = newOptions;
      this.selectedItems = this.selectedSearchItems;
      this.showMore = false;
    },
  },
};
</script>
